module.exports = __webpack_public_path__ + "img/form-bg.a51015e8.webp";